<template>
  <div id="app">
    <Logo></Logo>
    <div class="main-page">
      <div class="main-content">
        <router-view/>
      </div>
      <Footer></Footer>
    </div>
  </div>
</template>

<script>
import Logo from '@/components/Logo.vue';
import Footer from '@/components/Footer.vue';

export default {
  components: {
    Logo,
    Footer,
  },
};
</script>

<style lang="scss">
#app {
  font-family: Roboto, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-size: 1rem;
  min-height: 100%;
  display: flex;
  flex-direction: column;
  text-align: center;
  color: #2c3e50;
}

.main-page {
  flex: 1 1 auto;
  position: relative;
  overflow: hidden;
  background-image: url('./assets/images/lignes_background.png');
  background-position: bottom left;
  background-repeat: no-repeat;
  background-size: auto 33vh;
  @media (min-width: 768px) {
    margin-top: 110px;
  }
  margin-top: 66px;
}


Footer {
  position: absolute;
  bottom: 0;
  min-width: calc(100% - 6rem);
  margin: 0 3rem;
  @media (max-width: 768px) {
    margin: 0;
    min-width: 100%;
  }
}

  .main-content {
    display: inline-flex;
    width: 100%;
    margin-bottom: 24px;
    padding: 1em 0 calc(1em + 24px) 0;
  }
</style>
